import { translate } from "../../../core/i18n";
import { SimpleButton } from "./SimpleButton";

export const CloseButton = (props: { onClick: () => void, id?: string }) => {
  return (
    <SimpleButton 
      onClick={props.onClick} 
      id={props.id} 
      className="btn-dark close-btn" 
      title={translate("close")}>
      &times;
    </SimpleButton>
  );
}
